import React, { useState } from "react";
import { trackEvent } from "../analytics/ga";
import { getApiUrl } from "../api/apiClient";

const initialState = {
  name: "",
  email: "",
};

export const Newsletter = ({ ui }) => {
  const [{ name, email }, setState] = useState(initialState);
  const [status, setStatus] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name: field, value } = e.target;
    setState((prevState) => ({ ...prevState, [field]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("idle");
    setErrorMessage("");
    setSuccessMessage("");

    if (!name.trim() || !email.trim()) {
      setStatus("error");
      setErrorMessage(ui?.validation || ui?.error);
      return;
    }

    setSubmitting(true);

    try {
      const apiUrl = getApiUrl();
      const response = await fetch(`${apiUrl}/newsletter/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: name.trim(),
          email: email.trim(),
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(data.error || "Request failed");
      }

      clearState();
      setStatus("success");
      setSuccessMessage(data.message || ui?.success);
      trackEvent({
        category: "Newsletter",
        action: "Subscribe",
        label: "success",
      });
    } catch (err) {
      setStatus("error");
      setErrorMessage(err.message || ui?.error);
      trackEvent({
        category: "Newsletter",
        action: "Subscribe",
        label: "error",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div id="newsletter" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2">
          <div className="section-title">
            <h2>{ui?.title}</h2>
            {ui?.subtitle ? <p>{ui.subtitle}</p> : null}
          </div>

          {status === "success" ? (
            <p className="newsletter-form-status newsletter-form-status--success">
              {successMessage || ui?.success}
            </p>
          ) : (
            <form name="newsletterSubscribe" onSubmit={handleSubmit} noValidate>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      id="newsletter-name"
                      name="name"
                      className="form-control"
                      placeholder={ui?.namePlaceholder}
                      required
                      autoComplete="name"
                      value={name}
                      onChange={handleChange}
                      disabled={submitting}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <input
                      type="email"
                      id="newsletter-email"
                      name="email"
                      className="form-control"
                      placeholder={ui?.emailPlaceholder}
                      required
                      autoComplete="email"
                      value={email}
                      onChange={handleChange}
                      disabled={submitting}
                    />
                  </div>
                </div>
              </div>
              {status === "error" ? (
                <p className="newsletter-form-status newsletter-form-status--error">
                  {errorMessage || ui?.error}
                </p>
              ) : null}
              <button
                type="submit"
                className="btn btn-custom btn-lg"
                disabled={submitting}
              >
                {submitting ? ui?.subscribing : ui?.subscribe}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};
